import React, { useState } from "react";
import { RESTExecutor, withDomains } from "../../lib/domain";
import { Form, Input, Button, message, Card } from "antd";
import { useHistory } from "react-router-dom";
import GenerateTurnstileToken from "../../components/turnstile";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const customStyles = `
  .forgot-password-form .ant-form-item-explain-error {
    color: #E82E49 !important; font-size: 12px !important; font-family: 'Inter' !important; margin-top: 4px !important;
  }
  .forgot-password-form .invalid-input { outline: 1px #E82E49 solid !important; outline-offset: -1px !important; }
`;

const ForgotPasswordPage = ({ domains, ...props }) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const is_app_request = query.get("is_app_request");
  const [forgot_password_form] = Form.useForm();
  const [cloudflare_token, setCloudflareToken] = useState(null);
  const [emailSent, setEmailSent] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [emailSendMsg, setEmailSendMsg] = useState("");
  const history = useHistory();

  const validateAndSanitizeText = (text, maxLength = 100) => {
    if (!text) return text;
    return text
      .replace(/[<>"\\/{}[\];%&$]/g, "")
      .substring(0, maxLength)
      .trim();
  };

  const validateEmail = (email) => {
    if (!email) return false;
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return (
      emailPattern.test(email) && !email.includes("+") && !email.includes("=")
    );
  };

  const handleEmailChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[+=]/g, "");
    value = validateAndSanitizeText(value, 100);
    setIsEmailValid(validateEmail(value));
  };

  let send_mail = RESTExecutor.post()
    .config({
      label: "send_email",
    })
    .callbacks(
      (success) => {
        message.success("Email successfully sent");
        setEmailSent(true);
        setEmailSendMsg(success.result || "Email successfully sent");
        if (is_app_request) {
          setTimeout(() => {
            if (window.flutter_inappwebview) {
              window.flutter_inappwebview.callHandler(
                "forgetPasswordComplete",
                {
                  userId: 123,
                },
              );
            }
          }, 1500);
        }
      },
      (error) => {},
    )
    .connect(domains.password);

  const [emaildata, setData] = useState({ email: "" });

  const onFinish = (formData) => {
    if (!validateEmail(formData.email)) {
      message.error("Please enter a valid email address.");
      return;
    }
    formData.email = formData?.email?.trim();
    const fingerPrint = localStorage.getItem("device_fingerprint");
    send_mail.execute({
      ...formData,
      cloudflare_token,
      finger_print: fingerPrint,
    });
  };

  let { validation_errors = {}, error_message } = send_mail.response();
  let validateStatus =
    Object.keys(validation_errors || {}).length > 0 ? "error" : undefined;
  validateStatus = error_message ? "error" : undefined;

  if (emailSent) {
    return (
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "#EEF2F7",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <style>{customStyles}</style>
        <div
          style={{
            width: "100%",
            maxWidth: 544,
            padding: "48px 48px 40px 48px",
            background: "white",
            boxShadow: "0px 28px 62px rgba(37, 78, 207, 0.03)",
            borderRadius: 16,
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 24,
            display: "flex",
            "@media (max-width: 768px)": {
              padding: "32px 24px",
            },
          }}
        >
          <img
            src="images/tigg_logo.png"
            alt="Tigg Logo"
            style={{ width: 70, height: 33.18 }}
          />

          <div
            style={{
              textAlign: "center",
              gap: 8,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                color: "#343C46",
                fontSize: 24,
                fontFamily: "Inter",
                fontWeight: "700",
                marginBottom: 8,
              }}
            >
              Email Sent
            </div>
            <div
              style={{
                color: "#636972",
                fontSize: 12,
                fontFamily: "Inter",
                fontWeight: "400",
              }}
            >
              {emailSendMsg ||
                "If an account exists for this email, a password reset link will be sent shortly."}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src="images/emailsent.png"
              alt="Email sent illustration"
              style={{ width: 300 }}
            />
          </div>

          {!is_app_request && (
            <div
              onClick={() => {
                history.push("/");
              }}
              style={{
                textAlign: "center",
                cursor: "pointer",
                color: "#143E9F",
                fontSize: 12,
                fontFamily: "Inter",
                fontWeight: "600",
              }}
            >
              Return to Login
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        background: "#EEF2F7",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <style>{customStyles}</style>
      <div
        style={{
          width: "100%",
          maxWidth: 544,
          padding: "40px 48px",
          background: "white",
          boxShadow: "0px 28px 62px rgba(37, 78, 207, 0.03)",
          borderRadius: 16,
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: 20,
          display: "flex",
        }}
      >
        <div
          style={{
            alignSelf: "stretch",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: 24,
            display: "flex",
          }}
        >
          <div
            style={{
              flex: "1 1 0",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 2,
              display: "flex",
            }}
          >
            <div
              style={{
                alignSelf: "stretch",
                color: "#343C46",
                fontSize: 24,
                fontFamily: "Inter",
                fontWeight: "700",
              }}
            >
              Forgot Password
            </div>
            <div
              style={{
                alignSelf: "stretch",
                color: "#636972",
                fontSize: 12,
                fontFamily: "Inter",
                fontWeight: "400",
              }}
            >
              Enter the email address associated with your account and we will
              send you a link to reset your password.
            </div>
          </div>
          <img
            src="images/tigg_logo.png"
            alt="Tigg Logo"
            style={{ width: 70, height: 33.18 }}
          />
        </div>

        <div
          style={{
            alignSelf: "stretch",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: 16,
            display: "flex",
          }}
        >
          <Form
            form={forgot_password_form}
            name="forgot-password"
            className="forgot-password-form"
            style={{ width: "100%" }}
            onChange={(data) => {
              setData({ email: forgot_password_form.getFieldValue("email") });
            }}
            onFinish={onFinish}
          >
            <div
              style={{
                alignSelf: "stretch",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 4,
                display: "flex",
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  color: "#636972",
                  fontSize: 12,
                  fontFamily: "Inter",
                  fontWeight: "500",
                }}
              >
                Email*
              </div>
              <Form.Item
                name="email"
                validateStatus={!isEmailValid ? "error" : validateStatus}
                help={
                  !isEmailValid
                    ? "Please enter a valid email address."
                    : (validation_errors?.email ?? [null])[0] || error_message
                }
                rules={[
                  {
                    required: true,
                    message: "Please input your Email!",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address.",
                  },
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();
                      if (value.includes("+") || value.includes("=")) {
                        return Promise.reject(
                          new Error("Email cannot contain + or = characters."),
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
                style={{ width: "100%", marginBottom: 0 }}
              >
                <Input
                  placeholder="johndoe@email.com"
                  aria-label="Email address"
                  aria-required="true"
                  className={!isEmailValid ? "invalid-input" : ""}
                  onChange={handleEmailChange}
                  maxLength={100}
                  style={{
                    height: 40,
                    padding: 16,
                    borderRadius: 6,
                    border: "1px solid #E0E5EB",
                    fontSize: 12,
                    fontFamily: "Inter",
                    fontWeight: "400",
                  }}
                />
              </Form.Item>
            </div>

            <div style={{ marginBottom: 20 }}>
              <GenerateTurnstileToken
                setToken={(token) => {
                  setCloudflareToken(token);
                }}
              />
            </div>

            <div
              style={{
                alignSelf: "stretch",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 24,
                display: "flex",
              }}
            >
              <Form.Item style={{ width: "100%", marginBottom: 0 }}>
                <Button
                  loading={send_mail.response()?.fetching}
                  htmlType="submit"
                  disabled={!cloudflare_token || !isEmailValid}
                  style={{
                    width: "100%",
                    height: 48,
                    background:
                      cloudflare_token && isEmailValid ? "#143E9F" : "#CBD0D6",
                    boxShadow: "0px 8px 24px -8px rgba(20, 62, 159, 0.16)",
                    borderRadius: 6,
                    border: "none",
                    color: "white",
                    fontSize: 12,
                    fontFamily: "Inter",
                    fontWeight: "600",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Reset Password
                </Button>
              </Form.Item>

              {!is_app_request && (
                <div
                  onClick={() => {
                    history.push("/");
                  }}
                  style={{
                    textAlign: "center",
                    cursor: "pointer",
                    color: "#143E9F",
                    fontSize: 12,
                    fontFamily: "Inter",
                    fontWeight: "600",
                  }}
                >
                  Return to Login
                </div>
              )}
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default withDomains(ForgotPasswordPage, "password");
